import { getUkDateString } from '../helpers/dateHelpers';
import { SidebarTable } from './SidebarTable';

type Props = {
  pageName: string;
  date: Date;
  pageNumber: number;
  totalPages: number;
  designerInitials: string;
  drawerInitials: string;
};

export const PageDetailsBox = ({ pageName, date, pageNumber, totalPages, designerInitials, drawerInitials }: Props) => {
  return (
    <SidebarTable>
      <thead>
        <tr>
          <th colSpan={3}>{pageName}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={2} />
          <td>{getUkDateString(date)}</td>
        </tr>
        <tr>
          <td>DRAWN: {drawerInitials}</td>
          <td>DES: {designerInitials}</td>
          <td>
            Sheet {pageNumber} of {totalPages}
          </td>
        </tr>
      </tbody>
    </SidebarTable>
  );
};
